module.exports = app => {
  const services = {};
  return services;
};
